import { getScreenSize } from './_get-screen-size';

( function( document, window, getScreenSize ) {
	'use strict';

	var searchForm = document.querySelector( '.site-header .search-form' );

	if ( !searchForm ) {
		return;
	}

	var searchFieldWrapper = searchForm.querySelector( '.field_wrapper' ),
		expandButton = searchForm.querySelector( '.expand' ),
		searchField = searchForm.querySelector( '.field' );

	if ( getScreenSize( 'medium' ) || getScreenSize( 'large' ) ) {
		searchFieldWrapper.setAttribute( 'aria-hidden', 'true' );
	}

	var expandButtonClick = function( e ) {
		if ( getScreenSize( 'medium' ) || getScreenSize( 'large' ) ) {
			if ( 'true' === searchFieldWrapper.getAttribute( 'aria-hidden' ) ) {
				searchFieldWrapper.setAttribute( 'aria-hidden', 'false' );
				searchField.focus();
			} else {
				searchFieldWrapper.setAttribute( 'aria-hidden', 'true' );
			}
		} else {
			searchFieldWrapper.setAttribute( 'aria-hidden', 'false' );
			searchField.focus();
		}
	};

	// Weird fix for Edge not honoring click events.
	var listenType = navigator.userAgent.toLowerCase().indexOf( 'edge' ) !== -1 ? 'mouseup' : 'click';

	expandButton.addEventListener( listenType, expandButtonClick );

} )( document, window, getScreenSize );
